import auth from "./auth";
import account from "./account";
import controlCenter from "./controlCenter";
import departments from "./departments";
import tokens from "./tokens";

export default {
	...auth,
	...account,
	...controlCenter,
	...departments,
	...tokens,
};
